export class UserProfileConstants{
  public static readonly UserProfileToastKey: string = 'userProfileToast';
  public static readonly MyEmployeesProfileToastKey: string = 'myEmployeesProfileToast';
  public static readonly DuplicateFileUploadMessage: string = 'A file with same name already exists, Please upload the file with a different name.';
    public static readonly ConfirmationMessage = "You are about to delete an attached file. This action is not reversible. Do you want to proceed?";
    public static readonly SelectedeQMSScopeStyleClass = "selected-eQMS-scope";
    public static readonly UnselectedeQMSScopeStyleClass = "unselected-eQMS-scope";
    public static readonly PrimaryeQMSScopeIcon = "pi pi-star-fill";
    public static readonly UserProfileAttachmentFolderName = "eqmsdocumenttemplates";
    public static readonly NotApplicable = "N/A";
    public static readonly UserProfile_RoleAcessPermission_Fail: string = "Unable to fetch Roles permission";
    public static readonly MyEmployeesTab: string = 'myEmployees';
    public static readonly UserProfileTab: string = 'userProfile';
    public static readonly UpdateUserProfileHeader: string = 'Update Employee Profile';
    

    
  // Toaster Messages and Severity
  public static readonly Severity_Success: string = 'success';
  public static readonly Severity_Info: string = 'info';
  public static readonly Severity_Err: string = 'error';
  public static readonly Severity_Warning: string = 'warn';
  public static readonly Get_Training_Plan_Failure: string = 'Failed to load Training Plan';
  public static readonly UserProfile_Audit_Load_Failed: string = 'Failed to load user profile audit';

  public static readonly TrainingItems_StatusUpdatedMessage : string = 'The selected training item(s) have been updated to StatusName status'
  public static readonly TrainingItems_CoreOrElectiveUpdatedMessage : string = 'The selected training item(s) have been updated to CoreOrElective'
  public static readonly TrainingItems_TrainingStatusUpdatedMessage : string = 'The selected training item(s) have been updated to StatusName training status'

  
  public static readonly CoreOrElective_Items_with_Status_Removed: string =
  'The following Training Requirements have not been updated because they are in Status Removed: TrainingItemsCodes'
  public static readonly CoreOrElective_Items_in_Target_State: string =
  'The following Training Requirements have not been updated because they are already in the target state: TrainingItemsCodes'

  public static readonly Status_Items_in_Target_State: string =
  'The following Training Requirements have not been updated because they are already in the target status: TrainingItemsCodes'

  public static readonly TrainingStatus_Items_with_Otherthan_Complete_Status: string =
  'The following Training Requirements have not been updated because they are not in a Complete Training Status and cannot be revoked: TrainingItemsCodes'

  public static readonly TrainingStatus_Items_with_Otherthan_Locked_Status: string =
  'The following Training Requirements have not been updated because they are not in a Locked Training Status and cannot be unlocked: TrainingItemsCodes'

  
  public static readonly File_Upload_Failed : string = 'A Technical error occurred and the Name was not uploaded. Please contact technical support.'
  public static readonly UserProfileAttachments : string = 'User Profile Attachments'

   // confirmation Messages
   public static readonly User_Profile_Slider_Confirmation_Header: string = "Confirmation";
   public static readonly User_Profile__Confirmation_Text: string = "Any unsaved changes will be lost when closing the screen. Do you want to continue?";


   public static readonly UserProfile_Primary_eQMSScope_Required: string = "Primary eQMS Scope is required.";
   public static readonly UserProfile_Security_Permissions_Required: string = "Security permissions are required.";
   public static readonly UserProfile_Hire_Date_Required: string = "Hire Date is required.";

   public static readonly User_Profile_Info_Updated_Success: string = "User profile information updated successfully";



   public static readonly Assign_Skills_User_Required: string = 'A user must be selected before assigning skills.';
   public static readonly Assign_Skills_No_Skills_Selected: string = 'Select at least one skill to assign.';
   public static readonly Assign_Skills_Already_Assigned: string = 'The following Skills are already assigned to the user and cannot be assigned again.';
  public static readonly Assign_Skills_Already_In_Selection: string = 'The following Skills are already in the selection, it is not possible to add them again.';
   public static readonly Assign_Skills_Inactive: string = 'Inactive Skills cannot be assigned to users.';
   public static readonly Assign_Skills_Scope_Mismatch: string = 'The following Skill(s) cannot be assigned to this User as they are associated with an incompatible eQMS Scope.';
   public static readonly Assign_Skills_Saved_Successfully: string = 'Skill(s) Assignment was successful.';
   public static readonly Assign_Skills_Save_Failed: string = 'The skills could not be assigned. Please try again.';
   public static readonly Assign_Skills_Header_Text: string = 'Skill Assignment';

   public static readonly TrainingPlan_ReasonForRevocation : string = 'Reason for Training Status Revocation is required';
     public static readonly ReasonForTrainingItemRevocation : string ="Reason For Training Status Revocation"

     //Un-assign
    public static readonly TrainingPlan_UnAssign_Training_Item_Group_Btn_Label: string = 'Unassign Training Item Group';
    public static readonly TrainingPlan_UnAssign_Training_Item_Group_Header_Text: string = 'Unassign Training Item Group';
    public static readonly TrainingPlan_UnAssign_Training_Item_Group_Confirmation_Header_Text:string = "Confirmation";
    public static readonly TrainingPlan_UnAssign_Training_Item_Group_Confirmation_Message_Text:string = "Any unsaved changes will be lost. Do you want to continue?";
    public static readonly TrainingPlan_UnAssign_Training_Item_Group_Success_Message:string = "Selected Training Item Group(s) have been unassigned successfully from the Training Plan.";
    public static readonly TrainingPlan_UnAssign_Training_Item_Group_Error_Message:string = "A technical error occurred and Selected Training Item Group(s) were not unassigned from the Training Plan. Please retry and if this error persists, report it to your support contact.";
    public static readonly TrainingPlan_Fetch_Training_Item_Group_Error_Message:string = "A technical error occurred while fetching Training Item Group(s) referenced in Training Plan. Please retry and if this error persists, report it to your support contact.";
   
}
